import { api } from '@/lib/api';
import type {
  IApiResponse,
  IBimRelationshipGraph,
  ISchemaRelationshipSnapshot,
  ISchemaRelationshipSnapshotListItem,
} from '@skystone/shared';

interface ISnapshotListResponse {
  items: ISchemaRelationshipSnapshotListItem[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
  };
}

type ViewMode = 'unified' | 'org' | 'delivery' | 'issues';

export const schemaRelationshipApi = {
  getLatest: async (view?: ViewMode): Promise<ISchemaRelationshipSnapshot | null> => {
    const query = view ? `?view=${view}` : '';
    const result = await api.get<IApiResponse<ISchemaRelationshipSnapshot | null>>(`/schema-relationships/latest${query}`);
    return result.data;
  },

  getSnapshots: async (page = 1, pageSize = 20): Promise<ISnapshotListResponse> => {
    const result = await api.get<IApiResponse<ISnapshotListResponse>>(
      `/schema-relationships/snapshots?page=${page}&pageSize=${pageSize}`,
    );
    return result.data;
  },

  getSnapshotById: async (id: string, view?: ViewMode): Promise<ISchemaRelationshipSnapshot> => {
    const query = view ? `?view=${view}` : '';
    const result = await api.get<IApiResponse<ISchemaRelationshipSnapshot>>(`/schema-relationships/snapshots/${id}${query}`);
    return result.data;
  },

  getBimGraph: async (includeInactive = false): Promise<IBimRelationshipGraph> => {
    const query = includeInactive ? '?includeInactive=true' : '';
    const result = await api.get<IApiResponse<IBimRelationshipGraph>>(`/schema-relationships/bim-graph${query}`);
    return result.data;
  },
};
